import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { InAppBrowser } from '@vi-succ/inappbrowser';
import { environment } from '../environments/environment';
import { TrackingService } from './tracking.service';

@Injectable({ providedIn: 'root' })
export class BrowserService {
  constructor(
    private trackingService: TrackingService,
    private platform: Platform,
  ) {}

  public open(url: string, windowName?: string, title?: string) {
    if (this.platform.is('ios') && environment.production) {
      this.openIOSBrowser(url, title);
    } else if (this.platform.is('android') && environment.production) {
      this.openAndroidBrowser(url, title);
    } else {
      this.openDesktopBrowser(url, windowName);
    }
  }

  private openDesktopBrowser(url: string, windowName?: string) {
    window.open(url, windowName);
  }

  private openIOSBrowser(url: string, title?: string) {
    const resourceBlockRules = this.trackingService.isTrackingEnabled() ? undefined : environment.backend.blockRules;
    const appSchemes = ['com.viessmann.viparts'];

    InAppBrowser.openWebView({
      url,
      title,
      resourceBlockRules,
      appSchemes,
    });
  }

  private openAndroidBrowser(url: string, title?: string) {
    InAppBrowser.openWebView({ url, title });
  }
}
